import React from 'react'
import {connect} from "react-redux"
import {reduxForm} from 'redux-form'
import styles from './clients.scss'
import {find} from 'lodash/collection'
import Input from '../input'
import {trimObject, hasContent} from 'lib/helpers'
import ClientProfileForm from './clientProfileForm'
import { SelectWrapper } from '../../components/shared/select/SelectWrap'
import cs from 'classnames'

import i18n from 'lib/i18n'
const _ = i18n('clients')

const fieldType = {
	name: 'multiple',
	dateOfBirth: 'multiple',
	street: 'multiple',
	postalCode: 'multiple',
	email: 'multiple',
	phoneNumber: 'multiple',
	contractNumber: 'unique',
	clientNumber: 'unique',
    tarificationNumber: 'unique',
	claimNumber: 'unique',
    claimRefBroker: 'unique',
	licencePlate: "unique",
	companyRegistrationNumber: "multiple",
	myEasinsure: "multiple",
	needsAnalysis: "multiple",
	clientFile: "multiple",
}

const validate = values => {
	const errors = {}
	const formattedData = trimObject(values)
	const isEmpty = !hasContent(formattedData)
	if (isEmpty) {
		errors._error = 'emptyFields'
	}
	return errors
}

@reduxForm({
	form: "clients",
	fields: Object.keys(fieldType).concat(['characteristicValue', 'characteristicType']),
	error: React.PropTypes.string,
	validate,
})

@connect(state => {
    const clientAccess = state.app.security.actions

	const canCreateOnlyLegalClient = clientAccess && clientAccess.filter((item)=>(item.actionName == "createonlylegalclient" && item.actionAllowed == "true")).length > 0

	return ({
		canCreateOnlyLegalClient,
	})
})

export default class ClientsForm extends React.Component {

    constructor(props) {
        super(props)
        this.state = {characteristicOptions: [], characteristicValueTouched: false}
    }

    componentWillReceiveProps(nextPorps) {
        const {clientOptionsDict, lang} = nextPorps

        // process raw option dict data for select
        this.handleClientOptionsDictPropChange(clientOptionsDict, lang)
    }

    /**
     * This function process the client option dic (oracle provided translations) for
     * the react select of user characteristics
     * @param {object} clientOptionsDict - oracle provided translations
     * @param {string} lang - the current language of page
     */
    handleClientOptionsDictPropChange(clientOptionsDict, lang) {
        let characteristicOptions = []

        if (clientOptionsDict && clientOptionsDict.KENMERKTYPE) {
            let charTypes = clientOptionsDict.KENMERKTYPE
            Object.keys(charTypes).map((oneCharacteristicKey)=>{
                characteristicOptions.push({
                    value: oneCharacteristicKey,
                    label: charTypes[oneCharacteristicKey][lang]
                })
            })

            this.setState({characteristicOptions})
        }
    }

    /**
     * This will set the form value content in store
     */
    updateFormValue(value, field) {
        const {dispatch} = this.props

        dispatch({
            type: "redux-form/CHANGE",
            field: field.name,
            value: value && value.value || '',
            touch: value && (value.touched === false ? false : ( typeof value.touched == undefined ? field.touched : false )) ,
            form: "clients"
        })

        // to enforce of update of disabled buttons and validations refresh
        this.forceUpdate()
    }

    render() {
        const {canCreateOnlyLegalClient} = this.props
        const columns = [
            ['name', 'dateOfBirth', 'street', 'postalCode', 'email', 'phoneNumber'],
            [
                'contractNumber', 'clientNumber', 'tarificationNumber', 'claimNumber', 'claimRefBroker', 'licencePlate', 'companyRegistrationNumber', 'myEasinsure',
                'needsAnalysis', 'clientFile'
            ],
        ]

		const isTernary = {
			myEasinsure: true,
			needsAnalysis: true,
			clientFile: true,
		}

        const {fields, fields: {state, characteristicType, characteristicValue, contractNumber, claimRefBroker, claimNumber}, handleSubmit, error,
            createClientAccess, openModal, modalState} = this.props
        const {characteristicOptions} = this.state
		const usedField = find(fields, field => field.value)
		const usedType = usedField && fieldType[usedField.name]
        const invalid = error === 'emptyFields'

		return (
            <div className={styles.formContainerOuter}>
				<form onSubmit={handleSubmit} name="clients" className={`clients`}>
					<div className={styles.formContainer}>
						{columns.map((col, i) =>
							<div key={i} className={styles.column}>
								{col.map((name) =>
									<div key={name} className={styles.searchContainer}>
										<div className={styles.label}>
											{_(name)}
										</div>
										<div className={styles.clientSearchInput}>
											<Input
												autoFocus={name === 'name'}
												disabled={(usedType ? usedField.name !== name && (usedType === 'unique' ? true : (usedType !== fieldType[name])) : false) || characteristicType.value}
												type={isTernary[name] ? "ternary" : "text"}
												{...fields[name]}
											/>
										</div>
									</div>
								)}
							</div>
                        )}
                        <div key={'extraSearchPossibilitiesCol1Key'} className={styles.column}>
                            <div key={'extraSearchPossibilitiesRow1Key'} className={styles.searchContainerSeparated}>
                                <div className={styles.label}>
                                    {_('selectCharacteristicsLabel')}
                                </div>
                                <div className={styles.clientSearchInput}>
                                    <SelectWrapper
                                        className={cs(styles.inputCharacteristics, contractNumber.value ? styles.disabled : '')}
                                        autoFocus={false}
                                        isDisabled={contractNumber.value}
                                        isClearable
                                        options={characteristicOptions}
                                        {...characteristicType}
                                        onChange={(value) => {
                                            if (!value || !value.value) {
                                                this.setState({characteristicValueTouched: false})
                                                characteristicValue.onChange('')
                                            }
                                            characteristicType.onChange(value)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div key={'extraSearchPossibilitiesCol2Key'} className={styles.column}>
                            <div key={'extraSearchPossibilitiesRow2Key'} className={styles.searchContainerSeparated}>
                                <div className={styles.clientSearchInputLong}>
                                    <Input
                                        type={"text"}
                                        disabled={!characteristicType.value}
                                        value={characteristicValue.value}
                                        onChange={(value) => {
                                            this.setState({characteristicValueTouched: true})
                                            characteristicValue.onChange(value)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {!((characteristicValue.value && characteristicType.value) || (!characteristicValue.value && !characteristicType.value)) && this.state.characteristicValueTouched &&
                        <div key={'extraSearchPossibilitiesCol3Key'} className={cs(styles.column, styles.fullColumn)}>
                            <div key={'extraSearchPossibilitiesRow3Key'} className={styles.searchContainerSeparated}>
                                <div className={cs(styles.label, styles.error)}>
                                    {_('mustFillEachCharacteristicField')}
                                </div>
                            </div>
                        </div>}
					</div>
                    <div style={{ display: 'flex', gap: '2px', widdth: '100%' }}>
                        <button
                            className={styles.greyButton}
                            disabled={invalid || ((characteristicValue.value && !characteristicType.value) || (!characteristicValue.value && characteristicType.value))}
                            onClick={handleSubmit}
                            type="submit"
                        >
                            {_('submitbutton')}
                        </button>
                        {createClientAccess && 
                            <button
                                className={`${styles.greyButton} btn`} 
                                onClick={e => {
                                        openModal(e)
                                    }   
                                }
                            >
                                {_('create-profile')}
                            </button>}
                    </div>
                    </form>
                    {modalState && <div className={styles.overlayMap}></div>}
				<div className={cs(
                    styles.customCreateModal,
                    	modalState === true && styles.isOpened
					)}>
					{modalState && <ClientProfileForm canCreateOnlyLegalClient={canCreateOnlyLegalClient} openModal={openModal} />}
				</div>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./components/clients/form.jsx